<template>
    <div>
			<footer class="main-footer">
            <div class="float-right d-none d-sm-block">
                <b>v</b> {{ver}}
            </div>
            <strong>Техносервис Авторизованный Сервисный Центр</strong> 2005-{{year}}
        </footer>
    </div>
</template>

<script>
export default {
    data () {
        return {
            options: [],
            year: '',
            ver: '0.1',
						getver: "api/version"
        }
    },
    methods: {
			getVersion(){
				var app = this;
				axios
								.get(app.getver)
								.then(function (result) {
									app.ver=result.version;
								})
								.catch(function (error) {
								});
								}

    },
    mounted: function () {
			//	this.getVersion();
        var date = new Date();
        this.year = date.getFullYear();
    },
}
</script>

<style scoped>

</style>
